import { Pipe, PipeTransform } from '@angular/core';
import { TaskTracking } from '@shared/models/tasks';
import { DatesUtil } from '@shared/utilities/dates/dates.util';

@Pipe({
  name: 'taskTrackingStatus',
})
export class TaskTrackingStatusPipe implements PipeTransform {
  transform(date: string): TaskTracking {
    const dateDue = DatesUtil.convertToDate(date);

    if (!dateDue) {
      return 'upcoming';
    }

    const daysDue = DatesUtil.offsetInDays(dateDue);

    if (daysDue === 0) {
      return 'now';
    } else if (daysDue > 0) {
      return 'upcoming';
    } else {
      return 'overdue';
    }
  }
}